import api from "../../../../utils/api";

const DuplicateLeadApi = {
  // get all leads
  async fetchDuplicateLeads(params = {}) {
    const { queryString, queryParams, signal, ...restParams } = params; // Ignore unwanted params
    const response = await api.get(
      `/duplicate-lead?${queryString}&${queryParams}`,
      {
        params: restParams,
        signal,
      }
    );
    return { data: response?.data };
  },

  // get lead by id
  async fetchDuplicateLead(leadId, params = {}) {
    const response = await api.get(`/duplicate-lead/${leadId}`, { params });
    return response?.data?.data;
  },

  // add a lead
  async addDuplicateLead(leadData) {
    const response = await api.post("/duplicate-lead", leadData);
    return response?.data;
  },

  // update a lead
  async updateDuplicateLead(id, leadData) {
    const response = await api.patch(`/duplicate-lead/${id}`, leadData);
    return response.data;
  },

  async changleDuplicateLeadOwner(leadIdList, callerId) {
    const response = await api.patch(
      `/duplicate-lead/operation/bulk-lead-assignment`,
      {
        callerId,
        leadIdList,
      }
    );
    return response.data;
  },

  // fetchLeadsWithQuery for leads dashboard
  async fetchDuplicateLeadsWithQuery(params = {}) {
    const { queryKey, signal, ...restParams } = params; // Ignore unwanted params
    const response = await api.get("/analytics/lead", {
      params: restParams,
      signal,
    });
    return { data: response?.data };
  },
};

export default DuplicateLeadApi;
